const modules = [
  {
    name: 'Typography',
    loader: () => import('./Typography'),
    inline: false, // Set to true to bundle with app.bundle.js instead of separate chunk
  },
  {
    name: 'FormAnimation',
    loader: () => import('../../../modules/form-module/script.js'),
    inline: false,
  },
  {
    name: 'SelectC8',
    loader: () => import('../../../modules/form-module/select/SelectC8.js'),
    inline: false,
  },
  {
    name: 'NewsDetailSlider',
    loader: () => import('../4-helper/NewsDetailSlider.js'),
    inline: false,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'NewsShare',
    loader: () => import('../4-helper/NewsShare.js'),
    inline: false,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'Tabs',
    loader: () => import('../../../modules/tabs/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'Accordion',
    loader: () => import('../../../modules/accordion/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    // Reusable background/banner video handler (HTML5 / YouTube / Vimeo).
    // Attach via data-module="VideoPlayer" + .background-video markup.
    name: 'VideoPlayer',
    loader: () => import('../3-generics/VideoPlayer.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'Testimonial',
    loader: () => import('../../../modules/testimonial/script.js'),
    inline: false,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'MultiColumn',
    loader: () => import('../../../modules/multi-column/script.js'),
    inline: false,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'TestimonialCards',
    loader: () => import('../../../modules/testimonial-cards/script.js'),
    inline: false,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'LogoMarquee',
    loader: () => import('../../../modules/logo-marquee/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'ServiceCards',
    loader: () => import('../../../modules/service-cards/script.js'),
    inline: false,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'Benefits',
    loader: () => import('../../../modules/benefits/script.js'),
    inline: false,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'ResourceListings',
    loader: () => import('../../../modules/resource-listings/script.js'),
    inline: false,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'TimelineMilestones',
    loader: () => import('../../../modules/timeline-milestones/script.js'),
    inline: false,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'MapLocations',
    loader: () => import('../../../modules/map-locations/script.js'),
    inline: false,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'Map',
    loader: () => import('../../../modules/map/script.js'),
    inline: true, // bundled into app.bundle.js so window.initMap exists before Google Maps CDN callback
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'OneColumnContent',
    loader: () => import('../../../modules/one-column-content/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'HowItWorks',
    loader: () => import('../../../modules/how-it-works/script.js'),
    inline: false,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'ImageGallery',
    loader: () => import('../../../modules/image-gallery/script.js'),
    inline: false,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
];

export default [...modules];
